import dayjs from 'dayjs';
import 'dayjs/locale/fr';
import localizedFormat from 'dayjs/plugin/localizedFormat';
import relativeTime from 'dayjs/plugin/relativeTime';

// Pour la localisation en français

// Extension des plugins
dayjs.extend(relativeTime);
dayjs.extend(localizedFormat);

// Configuration de la locale
dayjs.locale('fr');

export default dayjs;
